// Import Swiper and modules
import Swiper from "swiper/bundle";

export const featuredCollections = () => {
  const $featuredCollectionsSections = document.querySelectorAll(
    "section.featured-collections"
  );
  if ($featuredCollectionsSections) {
    $featuredCollectionsSections.forEach(($featuredCollections) => {
      const $infoNav = $featuredCollections.querySelector(".info__nav");

      const $contentsSwiper = $featuredCollections.querySelector(
        ".contents__swiper.swiper"
      );
      if ($contentsSwiper) {
        const swiperConfig = {
          direction: "horizontal",
          speed: 1000,
          slidesPerView: 1.1,
          slidesPerGroup: 1,
          spaceBetween: 12,
          breakpoints: {
            768: {
              slidesPerView: 2.4,
              slidesPerGroup: 1,
              slidesPerGroupAuto: true,
              spaceBetween: 16,
            },
            1024: {
              slidesPerView: 3.6,
              slidesPerGroup: 1,
              slidesPerGroupAuto: true,
              spaceBetween: 32,
            },
          },
        };
        if ($infoNav) {
          const $infoNavButtonPrev = $infoNav.querySelector(
            ".nav__button.nav__button--prev"
          );
          const $infoNavButtonNext = $infoNav.querySelector(
            ".nav__button.nav__button--next"
          );
          swiperConfig.navigation = {
            disabledClass: "nav__button--disabled",
            prevEl: $infoNavButtonPrev,
            nextEl: $infoNavButtonNext,
          };
        }
        const swiperObject = new Swiper($contentsSwiper, swiperConfig);
      }
    });
  }
};

export default featuredCollections;
